<template>
  <div>
    <my-search
      timeScreen
      :order="1"
      :searchParams="searchParams"
      @searchEvent="searchEvent"
    />
    <!-- 表格展示查询的数据  -->
    <myTable
      :loading="loading"
      :tableData="tableData"
      :tableHeader="tableHeader"
    />
    <!-- 分页器 -->
    <my-pagination :childMsg="pageParams" @callFather="callFather" />
  </div>
</template>

<script>
import {
  reqConsumeList,
  reqGetByUser,
} from "@/network/workManage/consumingRec";
import { canSearch } from "../../utils/utils";
import mixins from "@/mixins/common";
export default {
  name: "consumingRec",
  mixins: [mixins],
  data() {
    return {
      searchParams: { timeOptions: [] },
      tableHeader: Object.freeze([
        {
          name: "用户",
          prop: "userZh",
        },
        {
          name: "消耗类型",
          prop: "type",
        },
        
        {
          name: "消耗数量",
          prop: "num",
        },
        {
          name: "文章标题",
          prop: "docTitle",
        },
        {
          name: "消费时间",
          prop: "createTime",
        },
      ]),
    };
  },
  methods: {
    async getInitData(isSearch) {
      let { timeOptions } = this.searchParams;
      let params = {
        current: isSearch ? 1 : this.pageParams.currentPage,
        size: this.pageParams.pageSize,
        startTime: timeOptions ? timeOptions[0] : undefined,
        endTime: timeOptions ? timeOptions[1] : undefined,
      };
      let { data } = await reqConsumeList(params);
      if (data.code == 200) {
        //  类型
        data.data.records.map((item) => {
          item.type = item.type == 1 ? "翻译文章" : "购买会员";
        });
        this.loading = false;
        this.tableData = data.data.records;
        this.pageParams.total = data.data.total;
        if (isSearch) this.pageParams.currentPage = 1;
      }
    },
    searchEvent() {
      //相同参数避免二次搜索
      // if (canSearch(this, this.searchParams)) return;
      // console.log("搜索了");
      this.getInitData(true);
    },
  },
};
</script>
<style>
</style>